import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionRegistrationResponse from "./exemptionRegistrationResponse";
import ExistingChargeResponse from "./existingChargeResponse";
import PossibleExemptionRegistrationResponse from "entities/possibleExemptionRegistrationResponse";

export default class ChargeRegistrationReport {
  @observable
  countryId: string;

  @observable
  @Type(() => Date)
  validSince: Date;

  @Type(() => ExemptionRegistrationResponse)
  @observable
  exemptions: ExemptionRegistrationResponse[] = [];

  @Type(() => PossibleExemptionRegistrationResponse)
  @observable
  possibleExemptions: PossibleExemptionRegistrationResponse[] = [];

  @Type(() => ExemptionRegistrationResponse)
  @observable
  charges: ExistingChargeResponse[] = [];
}
